import { extendTheme, type ThemeConfig } from '@chakra-ui/react'

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
}

export const theme = extendTheme({
  config,
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
  colors: {
    navy: {
      50: '#f4f6f9',
      100: '#e5e9f0',
      200: '#c8d1de',
      300: '#9caac0',
      400: '#6b7d99',
      500: '#4a5b74',
      600: '#334154',
      700: '#222d3d',
      800: '#151d29',
      900: '#0d141d',
    },
    accent: {
      50: '#eef4fb',
      100: '#d7e5f5',
      200: '#aecbea',
      300: '#7fadda',
      400: '#4f8dc7',
      500: '#1f6bab',
      600: '#175488',
      700: '#124169',
      800: '#0d2f4c',
      900: '#091f33',
    },
  },
  styles: {
    global: {
      'html, body': {
        color: 'navy.700',
        bg: 'white',
        fontSize: '16px',
        lineHeight: 1.6,
        WebkitFontSmoothing: 'antialiased',
      },
      '*::selection': {
        bg: 'accent.100',
      },
      ':focus-visible': {
        outline: '2px solid',
        outlineColor: 'accent.500',
        outlineOffset: '2px',
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'navy.800',
        fontWeight: 600,
        letterSpacing: '-0.02em',
      },
    },
    Button: {
      baseStyle: {
        fontWeight: 500,
        borderRadius: 'sm',
      },
      variants: {
        solidNavy: {
          bg: 'navy.800',
          color: 'white',
          _hover: { bg: 'navy.900' },
          _active: { bg: 'navy.900' },
        },
        outlineNavy: {
          bg: 'transparent',
          color: 'navy.800',
          border: '1px solid',
          borderColor: 'navy.200',
          _hover: { bg: 'navy.50', borderColor: 'navy.300' },
          _active: { bg: 'navy.100' },
        },
        outlineLight: {
          bg: 'transparent',
          color: 'white',
          border: '1px solid',
          borderColor: 'whiteAlpha.400',
          _hover: { bg: 'whiteAlpha.200', borderColor: 'whiteAlpha.700' },
        },
        solidLight: {
          bg: 'white',
          color: 'navy.800',
          _hover: { bg: 'navy.50' },
        },
      },
      sizes: {
        md: { h: '44px', px: 6, fontSize: 'sm' },
        lg: { h: '52px', px: 8, fontSize: 'md' },
      },
    },
  },
})
